// extracted by mini-css-extract-plugin
export default {"element":"style_element__7dTxr","text":"style_text__P4SVA","input":"style_input__AIWhk"};